import React from "react";
import { Col, Form, Row } from "react-bootstrap";

function AddItems() {
  return (
    <div>
      <p> AddItems</p>
      <div className="P-4 ">
        <h6 className=" section-heading">Service</h6>
        <Row className="mb-4">
          <Col md={4}>
            <Form.Group>
              <Form.Label>Services</Form.Label>
              {/* <Form.Select
                name="emirate"
                value={values.emirate}
                onChange={(e) => handleStateChange(e, setFieldValue)}
                onBlur={handleBlur}
                isInvalid={touched.emirate && errors.emirate}
                className={`form-input ${
                  values.emirate === "" ? "placeholder-style" : ""
                }`}
                style={{
                  height: "40px",
                  backgroundColor: "white",
                  border:
                    touched.emirate && errors.emirate
                      ? "1px solid #dc3545"
                      : "1px solid #E9ECEF",
                }}
              >
                <option value="">Select Emirate</option>
                {states.map((state) => (
                  <option key={state.state_id} value={state.state_id}>
                    {state.name}
                  </option>
                ))}
              </Form.Select>
              {touched.emirate && errors.emirate && (
                <div className="invalid-feedback d-block">{errors.emirate}</div>
              )} */}
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Service Type</Form.Label>
              {/* <Form.Select
                name="emirate"
                value={values.emirate}
                onChange={(e) => handleStateChange(e, setFieldValue)}
                onBlur={handleBlur}
                isInvalid={touched.emirate && errors.emirate}
                className={`form-input ${
                  values.emirate === "" ? "placeholder-style" : ""
                }`}
                style={{
                  height: "40px",
                  backgroundColor: "white",
                  border:
                    touched.emirate && errors.emirate
                      ? "1px solid #dc3545"
                      : "1px solid #E9ECEF",
                }}
              >
                <option value="">Select Emirate</option>
                {states.map((state) => (
                  <option key={state.state_id} value={state.state_id}>
                    {state.name}
                  </option>
                ))}
              </Form.Select>
              {touched.emirate && errors.emirate && (
                <div className="invalid-feedback d-block">{errors.emirate}</div>
              )} */}
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Service Offerings</Form.Label>
              {/* <Form.Select
                name="city"
                value={values.city}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={touched.city && errors.city}
                className={`form-input ${
                  values.city === "" ? "placeholder-style" : ""
                }`}
                style={{
                  height: "40px",
                  backgroundColor: "white",
                  border:
                    touched.city && errors.city
                      ? "1px solid #dc3545"
                      : "1px solid #E9ECEF",
                }}
              >
                <option value="">Select City</option>
                {cities.map((city) => (
                  <option key={city.city_id} value={city.city_id}>
                    {city.name}
                  </option>
                ))}
              </Form.Select>
              {touched.city && errors.city && (
                <div className="invalid-feedback d-block">{errors.city}</div>
              )} */}
            </Form.Group>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default AddItems;
